import { Brand } from 'constants/brand';
import FMAvatar from 'components/Icons/avatars/FMAvatar';
import GPAvatar from 'components/Icons/avatars/GPAvatar';

export const AVATAR_CONFIG = {
  [Brand.FM]: FMAvatar,
  [Brand.GP]: GPAvatar,
  [Brand.DAY1]: FMAvatar,
};
